module.exports = __webpack_public_path__ + "img/rating-icon-3.fe5d71ec.svg";